const healthAutoEvaluation = [
    "Muy bueno",
    "Bueno",
    "Regular",
    "Malo",
   "Muy malo",
  ];
  
  export default healthAutoEvaluation;
  